import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core'
import { DownloadParams, CardDownload } from '../models/download'

@Directive({
  standalone: false,
  selector: '[appCardDownload]'
})
export class CardDownloadDirective implements OnInit {

  // @todo determine best practice here
  // @see https://angular.io/guide/styleguide#avoid-aliasing-inputs-and-outputs
  // tslint:disable-next-line:no-input-rename
  @Input('appCardDownload') public downloadParams: DownloadParams
  private download: CardDownload

  constructor(private el: ElementRef) { }

  @HostListener('click') public onClick(): boolean {
    this.download.download()
    return false
  }

  public ngOnInit(): void {
    this.download = new CardDownload(this.downloadParams)
    this.el.nativeElement.href = this.download.componentUrl()
  }
}
